export enum ComponentPathSection {
  root = "root",
  parent = "parent"
}

export class ComponentUtils {
  static getComponent(form: any, componentPath: string): any {
    if (!form || !componentPath) return null;

    let formPart: any = form;
    let componentPathParts: string[] = componentPath.split("\\");

    if (!componentPathParts || !componentPathParts.length) return null;

    //if only name provided default to root get component
    if (componentPathParts.length == 1) return form.root.getComponent(componentPathParts[0]);

    //loop through parts till we get to final componet ex: \parent\parent\parent\componentName
    for (let i: number = 0; i < componentPathParts.length - 1; i++) {
      formPart = formPart[componentPathParts[i]] ? formPart[componentPathParts[i]] : formPart;
    }

    return formPart.getComponent ? formPart.getComponent(componentPathParts[componentPathParts.length - 1]) : null;
  }
}
